<template>

    <Grid class="page-header">

        <Column :span="headerSpan">

            <AOS type="fade-up" duration="1300" is-group anchor-placement="top-bottom">

                <Heading tag="h1" class="text-black" v-html="header"/>

            </AOS>

        </Column>

        <Column v-if="subHeader || $slots.default" :span="subHeaderSpan" class="mt-12 md:mt-10">

            <!-- <AOS type="fade-up"
                 delay="400"
                 duration="1300"
                 is-group
                 v-if="subHeader"
                 anchor-placement="top-bottom"> -->

                <DynamicContent v-if="typeof(subHeader) === 'array' || typeof(subHeader) === 'object'" :content="subHeader"/>

                <Paragraph v-else class="text-gray-600" v-html="subHeader"/>

            <!-- </AOS> -->

        </Column>

        <slot/>

    </Grid>

</template>

<script lang="ts">

    import { defineComponent } from 'vue'
    import Column from './Grid/Column.vue'
    import Grid from './Grid/Grid.vue'
    import DynamicContent from './DynamicContent.vue'
    import Heading from './Heading.vue'
    import Paragraph from './Paragraph.vue'

    export default defineComponent({
        name: 'PageHeader',
        components: {
            Grid,
            Heading,
            Paragraph,
            Column,
            DynamicContent
        },
        props: {
            header: { type: String, required: true },
            headerSpan: { type: [ Number, Array ], default: 6 },
            subHeaderSpan: { type: [ Number, Array ], default: 5 },
            subHeader: { type: [ String, Array ], default: null }
        }
    })

</script>
